import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageManager } from '@cutting/main/shared/helper/local-storage-manager.helper';
import { fuseAnimations } from '@fuse/animations';
import { FuseConfigService } from '@fuse/services/config.service';
import { MyValidator } from 'cloud-shared-lib';
import { Subject, of } from 'rxjs';
import { catchError, takeUntil, tap } from 'rxjs/operators';

import { HttpErrorResponse } from '@angular/common/http';
import { ForgotPasswordService } from './forgot-password.service';

@Component({
  selector: 'fuse-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  animations: fuseAnimations,
})
export class FuseForgotPasswordComponent implements OnInit, OnDestroy {
  forgotPasswordForm: UntypedFormGroup;
  forgotPasswordFormErrors: any;

  unsubscribe$: Subject<void> = new Subject();

  get userId(): number {
    return LocalStorageManager.regData;
  }

  constructor(
    private fuseConfigService: FuseConfigService,
    private formBuilder: UntypedFormBuilder,
    private activatedRoute: ActivatedRoute,
    private forgotPasswordService: ForgotPasswordService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {
    this.fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        toolbar: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        sidepanel: {
          hidden: true,
        },
      },
    };

    this.forgotPasswordFormErrors = {
      email: {},
    };
  }

  ngOnInit(): void {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, MyValidator.email]],
    });

    if (this.activatedRoute.snapshot.queryParams.email) {
      this.forgotPasswordForm.controls.email.setValue(this.activatedRoute.snapshot.queryParams.email);
      this.forgotPasswordForm.updateValueAndValidity();

      this.onSubmit();
    }

    this.forgotPasswordForm.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.onForgotPasswordFormValuesChanged();
    });
  }

  onForgotPasswordFormValuesChanged(): void {
    for (const field in this.forgotPasswordFormErrors) {
      // Clear previous errors
      this.forgotPasswordFormErrors[field] = {};

      // Get the control
      const control = this.forgotPasswordForm.get(field);

      if (control && control.dirty && !control.valid) {
        this.forgotPasswordFormErrors[field] = control.errors;
      }
    }
  }

  /*****************************************************************************/

  onSubmit(): void {
    if (!LocalStorageManager.regData) {
      this.router.navigate(['/client/auth/login']);
    }

    if (this.forgotPasswordForm.valid) {
      this.forgotPasswordService
        .sendEmailForRecovery(this.forgotPasswordForm.controls.email.value, LocalStorageManager.regData)
        .pipe(
          tap(() =>
            this.router.navigate(['/client/auth/mail-confirm'], {
              queryParams: { email: this.forgotPasswordForm.controls.email.value },
            })
          ),
          catchError((error: HttpErrorResponse) => {
            if (+error.status === 404) {
              this.snackBar.open($localize`Аккаунт с таким email не найден`);
            }

            if (+error.status === 403) {
              this.snackBar.open($localize`Аккаунт не активирован`);
            }

            return of(false);
          }),
          takeUntil(this.unsubscribe$)
        )
        .subscribe();
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
  }
}
